const REDUCE_MOTION_KEY = "cpl_reduce_motion";
const COMFORTABLE_SESSION_KEY = "cpl_comfortable_session";

export function readStoredReduceMotion(): boolean {
  try {
    return localStorage.getItem(REDUCE_MOTION_KEY) === "1";
  } catch {
    return false;
  }
}

export function writeStoredReduceMotion(enabled: boolean): void {
  try {
    localStorage.setItem(REDUCE_MOTION_KEY, enabled ? "1" : "0");
  } catch {
    /* ignore */
  }
}

export function readStoredComfortableSession(): boolean {
  try {
    return localStorage.getItem(COMFORTABLE_SESSION_KEY) === "1";
  } catch {
    return false;
  }
}

export function writeStoredComfortableSession(enabled: boolean): void {
  try {
    localStorage.setItem(COMFORTABLE_SESSION_KEY, enabled ? "1" : "0");
  } catch {
    /* ignore */
  }
}

export function applyReduceMotionToDocument(enabled: boolean): void {
  if (enabled) {
    document.documentElement.setAttribute("data-reduce-motion", "true");
  } else {
    document.documentElement.removeAttribute("data-reduce-motion");
  }
}

export function applyComfortableSessionToDocument(enabled: boolean): void {
  if (enabled) {
    document.documentElement.setAttribute("data-comfortable-session", "true");
  } else {
    document.documentElement.removeAttribute("data-comfortable-session");
  }
}

/** Apply both prefs from localStorage (theme-init.js). */
export function applyStudyComfortFromStorage(): void {
  applyReduceMotionToDocument(readStoredReduceMotion());
  applyComfortableSessionToDocument(readStoredComfortableSession());
}
